export default __webpack_public_path__ + "static/media/profile-icon.6b7d0730.svg";